var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (value) {if (value) {
if (value.OverallQualityScore && value.OverallQualityScore > 0) {
pug_html = pug_html + "\u003Cspan class=\"noWrap\"\u003E" + (pug.escape(null == (pug_interp = value.OverallQualityScore + '/10 ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cdiv" + (" class=\"status-image status_icon gridDetailsImage spritedimagealign quality-score-detail\""+pug.attr("title", value.title, true, true)+pug.attr("id", 'qsImage' + value.Id, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"noWrap\"\u003E" + (pug.escape(null == (pug_interp = '-') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;